import { render, staticRenderFns } from "./ReporteORI.vue?vue&type=template&id=43edc386&scoped=true"
import script from "./ReporteORI.vue?vue&type=script&lang=js"
export * from "./ReporteORI.vue?vue&type=script&lang=js"
import style0 from "./ReporteORI.vue?vue&type=style&index=0&id=43edc386&prod&scoped=true&lang=css"
import style1 from "../main.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43edc386",
  null
  
)

export default component.exports